import React from 'react';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

const FREE_MARKETING_TEXTS = 50;

const DefaultList = () => {
  const { t } = useTranslation();

  return (
    <ul>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markX}</li>
      <li>{S.markX}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{t('staffAndBusiness.subAndBilling.pricePlan.unlimitedDevicesLogins')}</li>
      <li>{S.markV}</li>
      <li>
        {S.markV} {t('staffAndBusiness.subAndBilling.pricePlan.unlimited')}
      </li>
      <li>-</li>
      <li>{FREE_MARKETING_TEXTS}</li>
    </ul>
  );
};

export default DefaultList;
